import React, { useState } from "react";
import { MdKeyboardArrowDown, MdKeyboardArrowRight } from "react-icons/md";

export default function Folder({
  folder,
  staticFolderId,
  folderId,
  setFolderId,
  setNewParentFolderId,
}) {
  const [isOpen, setIsOpen] = useState(false);

  const toggleOpen = (id) => {
    console.log(id);
    
    setIsOpen(!isOpen);
    if (setFolderId) {
      setFolderId(id);
    }
  };

  return (
    <div className="flex flex-col items-start w-full cursor-pointer">
      <button
        onClick={() => toggleOpen(staticFolderId)}
        className="flex items-center justify-left cursor-pointer w-full"
        style={{
          backgroundColor:
            folderId === staticFolderId ? "#172554" : "transparent",
          color: folderId === staticFolderId ? "white" : "black",
        }}
      >
        {isOpen ? <MdKeyboardArrowDown /> : <MdKeyboardArrowRight />}
        {folder.folderName}
      </button>
      <div style={{ display: isOpen ? "block" : "none", paddingLeft: 20 }} className="w-full">
        {Object.keys(folder.subfolder).map((key) => (
          <Folder
            key={key}
            folder={folder.subfolder[key]}
            staticFolderId={key}
            folderId={folderId}
            setFolderId={setFolderId}
          />
        ))}
      </div>
    </div>
  );
}
